export function formatTimeOfDay(minutesAfterMidnight: number): string {
    const hour24 = Math.floor(minutesAfterMidnight / 60) % 24;
    const minute = minutesAfterMidnight % 60;
    const period = hour24 < 12 ? 'am' : 'pm';
    const hour12 = hour24 % 12 || 12;

    return `${hour12}:${String(minute).padStart(2, '0')}${period}`;
}
